import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  FollowupReasonActionTypes,
  FollowupReasonsActionToggleLoading,
  FollowupReasonsPageLoaded,
  FollowupReasonsPageRequested,
  FollowupReasonsPageToggleLoading,
} from '../_actions/followup-reason.actions';
import { FollowUpService } from '../../services/follow-up.service';
import { QueryParamsModel } from '../../_base/crud';

@Injectable()
export class FollowupReasonEffects {
  showPageLoadingDistpatcher = new FollowupReasonsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new FollowupReasonsPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new FollowupReasonsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new FollowupReasonsActionToggleLoading({ isLoading: false });

  @Effect()
  loadFollowupReasonsPage$ = this.actions$.pipe(
    ofType<FollowupReasonsPageRequested>(FollowupReasonActionTypes.FollowupReasonsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      return this.followUpService.findReasons(payload.page).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((result) => {
          return new FollowupReasonsPageLoaded({
            reasons: result?.data,
            totalCount: result.count,
            page: new QueryParamsModel({}),
          });
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private followUpService: FollowUpService,
  ) {}
}
